// ProductAddOrEditModal.js
import React, { Component } from "react";
import CartContext from "./CartContext";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import Select from "react-select";
import axios from "axios";
import Switch from "react-switch";
import Swal from "sweetalert2";

import {
  FloatingLabel,
  OverlayTrigger,
  Tooltip,
  Table,
  InputGroup,
  Modal,
  Button,
  Row,
  Col,
  Form,
} from "react-bootstrap";

export class ProductAddOrEditModal extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);

    this.state = {
      prod: {
        hideMe: false,
        deliveryCostIncluded: false,
        hideWhenOutOfStock: true,
        productVariantType: 1,
        takeAwayChargeInPercentage: 0,
        homeDeliveryChargeInPercentage: 0,
        mrp: 0,
        mrpWholeSale: 0,
        mrpSuperWholeSale: 0,
        discount: 0,
        inStockQty: 0,
        thickness: 0,
        length: 0,
        width: 0,
        purchasePrice: 0,
        unit: "piece",
        weightVariant: false,

        // customField1/2/3, sku, hsncode, etc. will be set via handlers
      },

      // 🔽 ADDED
      storageUnits: [],
      tanks: [],
      partitions: [],

      rawmaterialwarehouse: [],
      mainCategoryId: "",
      sellingPrice: 0,

      productImages: [],
      productMultiVariants: [],

      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,

      ProductDataType: [],
      ProductDataTypeValues: [],
      images: [],

      selectedOption: null,
      firstLoad: false,
      reload: false,
    };
  }

  generateUniqueSKU = () => {
    const existingSkus = new Set(
      (this.context.prods || [])
        .map((p) => (p.sku || "").toString())
        .filter(Boolean),
    );

    let sku = "";
    let attempts = 0;

    while (attempts < 1000) {
      sku = Math.floor(10000 + Math.random() * 90000).toString(); // 5-digit
      if (!existingSkus.has(sku)) break;
      attempts++;
    }

    if (existingSkus.has(sku)) {
      alert("Unable to generate unique SKU. Please enter manually.");
      return;
    }

    this.updateProdField("sku", sku);
  };

  loadStorageUnits = async () => {
    const res = await axios.get(process.env.REACT_APP_API + "StorageUnit", {
      params: { storeId: this.context.storeId },
    });
    this.setState({ storageUnits: res.data });
  };

  loadTanks = async (storeUnitId) => {
    if (!storeUnitId) {
      this.setState({ tanks: [], partitions: [] });
      return;
    }

    const res = await axios.get(process.env.REACT_APP_API + "Tank", {
      params: {
        storeId: this.context.storeId,
        storageUnitId: storeUnitId,
      },
    });

    this.setState({ tanks: res.data });
  };

  loadPartitions = async (tankId) => {
    if (!tankId) {
      this.setState({ partitions: [] });
      return;
    }

    const res = await axios.get(process.env.REACT_APP_API + "TankPartition", {
      params: {
        storeId: this.context.storeId,
        tankId,
      },
    });

    this.setState({ partitions: res.data });
  };

  // -------------------- Helpers --------------------
  setProd = (updater) => {
    this.setState((prev) => {
      const nextProd =
        typeof updater === "function" ? updater(prev.prod) : updater;
      return { prod: nextProd };
    }, this.updateSellingPrice);
  };

  updateProdField = (name, value) => {
    this.setProd((prevProd) => ({ ...prevProd, [name]: value }));
  };

  numberOrZero = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  numberOrNull = (v) => {
    if (v === "" || v === null || v === undefined) return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  };

  // -------------------- UI Utils --------------------
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false }, () => {
      this.props.onHide();
    });
  };

  ShowMessagBox = (title, message) => {
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });
  };

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  // -------------------- Images Load --------------------
  LoadImages = () => {
    const timages =
      (this.context.images || []).map((r) => ({
        value: r.name,
        label: r.name,
      })) || [];
    this.setState({ images: timages });
  };

  // -------------------- API --------------------
  GetProductDataType = () => {
    axios
      .get(
        `${process.env.REACT_APP_API}StoreManager/GetProductDataType/${this.context.storeId}`,
      )
      .then((response) => {
        if (response.status === 200) {
          this.setState({ ProductDataType: response.data });
        }
      })
      .catch((error) => {
        console.error("GetProductDataType - There was an error! ", error);
      });
  };

  GetProductDataTypeValues = () => {
    axios
      .get(
        `${process.env.REACT_APP_API}StoreManager/GetAllProductDataTypeValues/${this.context.storeId}`,
      )
      .then((response) => {
        if (response.status === 200) {
          this.setState({ ProductDataTypeValues: response.data });
        }
      })
      .catch((error) => {
        console.error("GetProductDataTypeValues - There was an error! ", error);
      });
  };

  GetRawMaterialWarehouses = () => {
    fetch(
      `${process.env.REACT_APP_API}Warehouse/GetRawMaterialWarehouses/${this.context.storeId}`,
    )
      .then((r) => r.json())
      .then((data) => {
        if (data?.status === 400) return;
        this.setState(
          { rawmaterialwarehouse: Array.isArray(data) ? data : [] },
          () => this.setState({ reload: true }),
        );
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  // -------------------- Lifecycle --------------------
  componentDidMount() {
    if (!this.state.firstLoad) {
      this.setState({ firstLoad: true });

      this.loadStorageUnits();

      this.GetRawMaterialWarehouses();
      this.GetProductDataType();
      this.GetProductDataTypeValues();
      if (this.state.images.length === 0) this.LoadImages();

      if (this.props.Type === "Edit" && this.props.prod) {
        const p = this.props.prod;
        const { storeUnitId, tankId } = this.props.prod;

        if (storeUnitId) {
          this.loadTanks(storeUnitId);
        }

        if (tankId) {
          this.loadPartitions(tankId);
        }

        this.setState(
          {
            prod: { ...p },
            mainCategoryId: this.props.mainCategoryId || "",
            productImages: (p.productImages || [])
              .slice()
              .sort((a, b) => a.seqNo - b.seqNo),
            productMultiVariants: (p.productCustomFields || [])
              .slice()
              .sort((a, b) => a.seqNo - b.seqNo),
          },
          () => {
            this.setState({
              sellingPrice:
                Number(this.state.prod.mrp || 0) -
                (Number(this.state.prod.mrp || 0) *
                  Number(this.state.prod.discount || 0)) /
                  100,
            });
          },
        );
      } else {
        // defaults from store settings
        const defaultVariant =
          this.context?.storeSettings?.defaultProductVariantType ?? 1;
        const defaultUnit = this.context?.storeSettings?.defaultUnit ?? "piece";
        this.setProd((prev) => ({
          ...prev,
          productVariantType: defaultVariant,
          unit: defaultUnit,
        }));
      }
    }
  }

  // -------------------- Computations --------------------
  updateSellingPrice = () => {
    const mrp = Number(this.state.prod.mrp || 0);
    const disc = Number(this.state.prod.discount || 0);
    this.setState({
      sellingPrice: mrp - (mrp * disc) / 100,
    });
  };

  // -------------------- Validation --------------------
  ValidateForm = () => {
    const { mainCategoryId, prod, productMultiVariants } = this.state;

    if (!mainCategoryId) {
      alert("Please select MainCategory!");
      return false;
    }
    if (!prod?.subCategoryId) {
      alert("Please select SubCategory!");
      return false;
    }

    // Variant Type specific checks
    if (Number(prod.productVariantType) === 2) {
      const f1 = prod.customField1;
      const f2 = prod.customField2;
      const f3 = prod.customField3;
      const hasAnyField =
        (f1 !== "" && f1 !== undefined) ||
        (f2 !== "" && f2 !== undefined) ||
        (f3 !== "" && f3 !== undefined);

      if (!hasAnyField) {
        alert("Configure at least one Custom Field");
        return false;
      }
      if (!productMultiVariants || productMultiVariants.length === 0) {
        alert("Add Product Multivariants!");
        return false;
      }
    }

    return true;
  };

  // -------------------- Submit --------------------
  AddProductInDB = () => {
    const prod = { ...this.state.prod, storeId: this.context.storeId };

    if (
      Number(prod.productVariantType) === 2 &&
      this.state.productMultiVariants.length > 0
    ) {
      const sorted = this.state.productMultiVariants
        .slice()
        .sort((a, b) => a.seqNo - b.seqNo);
      prod.mrp = sorted[0].mrp;
      prod.discount = sorted[0].discount;
      prod.productCustomFields = sorted;
    }

    // Attach images if present (preserve your original flow; add only if needed)
    if (this.state.productImages?.length) {
      prod.productImages = this.state.productImages
        .slice()
        .sort((a, b) => a.seqNo - b.seqNo);
    }

    // normalize numbers
    prod.mrp = this.numberOrZero(prod.mrp);
    prod.mrpWholeSale = this.numberOrZero(prod.mrpWholeSale);
    prod.mrpSuperWholeSale = this.numberOrZero(prod.mrpSuperWholeSale);
    prod.discount = this.numberOrZero(prod.discount);
    prod.inStockQty = this.numberOrZero(prod.inStockQty);
    prod.purchasePrice = this.numberOrZero(prod.purchasePrice);
    prod.thickness = this.numberOrZero(prod.thickness);
    prod.width = this.numberOrZero(prod.width);
    prod.length = this.numberOrZero(prod.length);
    prod.pieceCount = this.numberOrZero(prod.pieceCount);
    prod.productVariantType =
      this.context?.storeSettings?.defaultProductVariantType ?? 1;
    prod.storeUnitId =
      !prod.storeUnitId || prod.storeUnitId === "" ? null : prod.storeUnitId;

    prod.tankId = !prod.tankId || prod.tankId === "" ? null : prod.tankId;

    prod.partitionId =
      !prod.partitionId || prod.partitionId === "" ? null : prod.partitionId;
    this.ShowLoadSpinner();

    fetch(`${process.env.REACT_APP_API}StoreManager/AddProduct/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(prod),
    })
      .then((response) => response.json())
      .then(() => {
        // TODO: Ideally inform list via lift-state instead of global call
        this.context.GetAllProducts?.();
        this.HideLoadSpinner();
        Swal.fire({
          title: "Information",
          text: "Added Successfully!",
          timer: 3000,
        }).then(() => {
          this.props.onHide?.();
        });
      })
      .catch((error) => {
        this.HideLoadSpinner();
        this.ShowMessagBox("Failed", "Unable to Add! Try later");
        console.error("AddProductInDB failed:", error);
      });
  };

  UpdateProductInDB = () => {
    let prod = { ...this.state.prod };

    if (
      Number(prod.productVariantType) === 2 &&
      this.state.productMultiVariants.length > 0
    ) {
      const sorted = this.state.productMultiVariants
        .slice()
        .sort((a, b) => a.seqNo - b.seqNo);
      prod.mrp = sorted[0].mrp;
      prod.discount = sorted[0].discount;
      prod.productCustomFields = sorted;
    }

    if (this.state.productImages?.length) {
      prod.productImages = this.state.productImages
        .slice()
        .sort((a, b) => a.seqNo - b.seqNo);
    }

    // normalize numbers
    prod.mrp = this.numberOrZero(prod.mrp);
    prod.discount = this.numberOrZero(prod.discount);
    prod.inStockQty = this.numberOrZero(prod.inStockQty);
    prod.purchasePrice = this.numberOrZero(prod.purchasePrice);
    prod.thickness = this.numberOrZero(prod.thickness);
    prod.width = this.numberOrZero(prod.width);
    prod.length = this.numberOrZero(prod.length);
    prod.pieceCount = this.numberOrZero(prod.pieceCount);

    this.ShowLoadSpinner();

    fetch(
      `${process.env.REACT_APP_API}StoreManager/UpdateProduct/${this.props?.prod?.id}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(prod),
      },
    )
      .then((res) => {
        if (res.status === 200) {
          this.context.GetAllProducts?.();
          this.HideLoadSpinner();
          // this.ShowMessagBox("Information", "Updated Successfully");
          Swal.fire({
            title: "Information",
            text: "Updated Successfully!",
            timer: 3000,
          }).then(() => {
            this.props.onHide?.();
          });
        } else {
          this.HideLoadSpinner();
          this.ShowMessagBox("Failed", "Not Updated");
        }
      })
      .catch((error) => {
        this.HideLoadSpinner();
        this.ShowMessagBox("Failed", "Not Updated");
        console.error("UpdateProductInDB failed:", error);
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    if (!this.ValidateForm()) {
      event.stopPropagation();
      return;
    }

    if (this.props.Type === "Edit") this.UpdateProductInDB();
    else this.AddProductInDB();
  };

  // -------------------- Handlers --------------------
  handleAddImages = () => {
    this.setState((prev) => ({
      productImages: [
        ...prev.productImages,
        {
          storeId: this.context.storeId,
          fileName: "",
          seqNo: (prev.productImages?.length || 0) + 1,
        },
      ],
    }));
  };

  handleImageSelectionChange = (e, index) => {
    this.setState((prev) => {
      const list = prev.productImages.slice();
      if (!list[index]) return null;
      list[index] = { ...list[index], fileName: e?.value || "" };
      return { productImages: list };
    });
  };

  handlePosterSelectionChange = (e, index) => {
    this.setState((prev) => {
      const list = prev.productImages.slice();
      if (!list[index]) return null;
      list[index] = { ...list[index], posterName: e?.value || "" };
      return { productImages: list };
    });
  };

  handleImageseqNoChange = (e, index) => {
    const { name, value } = e.target;
    this.setState((prev) => {
      const list = prev.productImages.slice();
      if (!list[index]) return null;
      list[index] = { ...list[index], [name]: Number(value) || 0 };
      return { productImages: list };
    });
  };

  handleRemoveClick = (index) => {
    this.setState((prev) => {
      const list = prev.productImages.slice();
      if (index < 0 || index >= list.length) return null;
      list.splice(index, 1);
      return { productImages: list };
    });
  };

  handleAddProductMultiVariants = () => {
    const { prod } = this.state;
    const needsField =
      (prod.customField1 && prod.customField1 !== "") ||
      (prod.customField2 && prod.customField2 !== "") ||
      (prod.customField3 && prod.customField3 !== "");

    if (!needsField) {
      alert("Select at least one Custom Field before adding a row!");
      return;
    }

    this.setState((prev) => ({
      productMultiVariants: [
        ...prev.productMultiVariants,
        {
          customValue1: "",
          customValue2: "",
          customValue3: "",
          seqNo: (prev.productMultiVariants?.length || 0) + 1,
          mrp: 0,
          discount: 0,
          inStockQty: 0,
          sku: "",
          storeId: this.context.storeId,
        },
      ],
    }));
  };

  IsDuplicateProductVariants = (draftList, index, name, value) => {
    const row = draftList[index];
    if (!row) return false;

    if (name === "customValue1") {
      return draftList.some(
        (f, i) =>
          i !== index &&
          f.customValue1 === value &&
          f.customValue2 === row.customValue2,
      );
    }
    if (name === "customValue2") {
      return draftList.some(
        (f, i) =>
          i !== index &&
          f.customValue1 === row.customValue1 &&
          f.customValue2 === value,
      );
    }
    return false;
  };

  handleProductMultivariantChange = (e, index) => {
    const { name, value } = e.target;

    this.setState((prev) => {
      const list = prev.productMultiVariants.slice();
      if (!list[index]) return null;

      if (name === "customValue1" || name === "customValue2") {
        if (this.IsDuplicateProductVariants(list, index, name, value)) {
          alert("Duplicate entry! Same row already exists!");
          return null;
        }
      }

      let v = value;
      if (["mrp", "discount", "seqNo", "inStockQty"].includes(name)) {
        const num = Number(value);
        v = Number.isFinite(num) ? num : 0;
      }

      list[index] = { ...list[index], [name]: v };
      return { productMultiVariants: list };
    });
  };

  handleRemoveProductMultiVariantClick = (index) => {
    this.setState((prev) => {
      const list = prev.productMultiVariants.slice();
      if (index < 0 || index >= list.length) return null;
      list.splice(index, 1);
      return { productMultiVariants: list };
    });
  };

  Image2Change = (e) => {
    this.updateProdField("image2", e?.value || "");
  };

  // Master field change handler (immutable)
  handleInputChange = (e) => {
    const { name, value } = e.target;
    const trimmed = typeof value === "string" ? value : value;

    let prod = { ...this.state.prod };

    switch (name.trim()) {
      case "warehouseId":
        prod.warehouseId = trimmed || null;
        this.setState({ prod });
        break;

      case "storeUnitId":
        prod.storeUnitId = trimmed || null;
        prod.tankId = null; // reset dependent
        prod.partitionId = null; // reset dependent

        this.setState({ prod }, () => {
          if (trimmed) this.loadTanks(trimmed);
        });
        break;

      case "tankId":
        prod.tankId = trimmed || null;
        prod.partitionId = null; // reset dependent

        this.setState({ prod }, () => {
          if (trimmed) this.loadPartitions(trimmed);
        });
        break;

      case "partitionId":
        prod.partitionId = trimmed || null;
        this.setState({ prod });
        break;

      case "productVariantType":
        this.updateProdField(name, Number(trimmed) || 1);
        break;

      case "sku":
      case "internalId":
      case "hsncode":
      case "batchId":
      case "qualityId":
        this.updateProdField(name, (trimmed || "").replace(/\s/g, ""));
        break;

      case "purchasePrice":
      case "mrp":
      case "mrpWholeSale":
      case "mrpSuperWholeSale":
      case "sellingPriceBusinessRuleId":
      case "discount":
      case "localWt":
      case "inStockQty":
      case "takeAwayChargeInPercentage":
      case "homeDeliveryChargeInPercentage":
      case "thickness":
      case "width":
      case "length":
        this.updateProdField(name, trimmed);
        break;

      default:
        this.updateProdField(name, trimmed);
        break;
    }
  };

  // Switches: use direct mapping (no inverted logic in setter)
  handleHidemeChange = (checked) => {
    // "Show on Portal?" switch uses checked = !hideMe in UI; set hideMe = !checked
    this.updateProdField("hideMe", !checked);
  };

  handleDeliveryPriceIncluded = (checked) => {
    this.updateProdField("deliveryCostIncluded", !!checked);
  };

  handleHidemeWhenOutOfStockChange = (checked) => {
    // "Show When Out-of-Stock?" => checked true means NOT hide when OOS
    this.updateProdField("hideWhenOutOfStock", !checked);
  };

  handleWeightVariantChange = (checked) => {
    this.updateProdField("weightVariant", !!checked);
  };

  onMainCategorySelectChangeEvent = (e) => {
    const val = e.target.value;
    this.setState({ mainCategoryId: val }, () => {
      // Reset subcategory on main change
      this.updateProdField("subCategoryId", 0);
    });
  };

  // -------------------- Render --------------------
  render() {
    const gridStyle = {
      display: "grid",
      gap: "0.6rem",
      gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
      alignItems: "start",
    };
    const {
      msgboxOpen,
      msgboxTitle,
      msgboxMessage,
      loadSpinnerOpen,
      rawmaterialwarehouse,
      productImages,
      images,
      ProductDataTypeValues,
      productMultiVariants,
      mainCategoryId,
      prod,
    } = this.state;

    const showEcom =
      this.context.storeSettings?.showEcommerceModule === true ||
      this.context.storeSettings?.showEcommerceModule === undefined;

    return (
      <div className="container ">
        <Modal
          {...this.props}
          size="lg"
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName={
            this.context.store.businessTypeId ===
            this.context.BusinessTypes.STEELTRADERS
              ? ""
              : "order-summary-mobile"
          }
        >
          {msgboxOpen && (
            <MessageBox
              open={msgboxOpen}
              title={msgboxTitle}
              message={msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          )}

          {loadSpinnerOpen && <LoadSpinner open="true" />}

          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning" size="xl">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.Type === "Edit" ? "Edit Product" : "Add Product"}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="show-grid ">
              <div className="p-1">
                <div>
                  <Row style={{ fontSize: "12pt" }}>
                    {/* Left Column */}
                    <Col md={3} className="m-0 p-0">
                      <div className="mx-1 p-2 bg-light border CornersRoundedSmall">
                        {/* Warehouse */}
                        <FloatingLabel label="Warehouse " className="mb-1">
                          <Form.Select
                            name="warehouseId"
                            value={prod.warehouseId || ""}
                            align="center"
                            autoFocus
                            className="text-start"
                            autoComplete="off"
                            onChange={this.handleInputChange}
                          >
                            <option value=""></option>
                            {rawmaterialwarehouse.map((m) => (
                              <option key={m.id} value={m.id}>
                                {m.name}
                              </option>
                            ))}
                          </Form.Select>
                        </FloatingLabel>

                        {/* Product Name - English */}
                        <FloatingLabel label="Product Name *" className="mb-1">
                          <Form.Control
                            as="textarea"
                            name="name"
                            rows={2}
                            maxLength={119}
                            value={prod.name || ""}
                            required
                            placeholder="Enter product name in English"
                            autoComplete="off"
                            onChange={this.handleInputChange}
                          />
                        </FloatingLabel>

                        <FloatingLabel label="Remarks" className="mb-1">
                          <Form.Control
                            type="text"
                            name="remarks"
                            maxLength={254}
                            value={prod.remarks || ""}
                            placeholder="Remarks"
                            autoComplete="off"
                            onChange={this.handleInputChange}
                          />
                        </FloatingLabel>

                        {/* Product Name - 2nd Language */}
                        <FloatingLabel
                          label="Product Name (in 2nd Language/Unicode)"
                          className="mb-1"
                        >
                          <Form.Control
                            as="textarea"
                            name="name2"
                            rows={2}
                            maxLength={119}
                            value={prod.name2 || ""}
                            placeholder="Enter product name in 2nd language"
                            autoComplete="off"
                            onChange={this.handleInputChange}
                          />
                        </FloatingLabel>

                        {/* Main Category */}
                        <FloatingLabel label="Main Category *" className="mb-1">
                          <Form.Select
                            name="mainCategoryId"
                            value={mainCategoryId}
                            required
                            onChange={this.onMainCategorySelectChangeEvent}
                          >
                            <option value="">-- Select Main Category --</option>
                            {this.context.mainCategories.map((cat) => (
                              <option key={cat.id} value={cat.id}>
                                {cat.name}
                              </option>
                            ))}
                          </Form.Select>
                        </FloatingLabel>

                        {/* Sub Category */}
                        <FloatingLabel label="Sub Category *" className="mb-1">
                          <Form.Select
                            name="subCategoryId"
                            value={prod.subCategoryId || ""}
                            required
                            onChange={this.handleInputChange}
                          >
                            <option value="">-- Select Sub Category --</option>
                            {this.context.subCategories
                              .filter(
                                (sub) => sub.mainCategoryId === mainCategoryId,
                              )
                              .map((sub) => (
                                <option key={sub.id} value={sub.id}>
                                  {sub.name}
                                </option>
                              ))}
                          </Form.Select>
                        </FloatingLabel>

                        {/* Brand */}
                        <FloatingLabel label="Brand Name" className="mb-1">
                          <Form.Select
                            name="brandId"
                            value={prod.brandId || ""}
                            onChange={this.handleInputChange}
                          >
                            <option value="">-- Select Brand --</option>
                            {this.context.brands.map((brand) => (
                              <option key={brand.id} value={brand.id}>
                                {brand.brandName}
                              </option>
                            ))}
                          </Form.Select>
                        </FloatingLabel>

                        {/* Weight Variant Toggle */}
                        <Form.Group as={Row} className="mb-2">
                          <Form.Label column sm={8}>
                            Weight Variant while Sell
                          </Form.Label>
                          <Col sm={4}>
                            <Switch
                              onChange={this.handleWeightVariantChange}
                              checked={!!prod.weightVariant}
                            />
                          </Col>
                        </Form.Group>

                        {/* Delivery Price Included Toggle */}
                        <Form.Group
                          as={Row}
                          className="mb-2"
                          controlId="deliveryIncluded"
                        >
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                When enabled, this product's delivery cost will
                                not be added to the total order cost.
                              </Tooltip>
                            }
                          >
                            <Form.Label
                              column
                              sm={8}
                              className="d-flex align-items-center"
                            >
                              Delivery Price Included?&nbsp;
                              <span className="text-primary fw-bold">
                                Help!
                              </span>
                            </Form.Label>
                          </OverlayTrigger>
                          <Col sm={4}>
                            <Switch
                              onChange={this.handleDeliveryPriceIncluded}
                              checked={!!prod.deliveryCostIncluded}
                            />
                          </Col>
                        </Form.Group>
                      </div>
                    </Col>

                    {/* Middle Column */}
                    <Col
                      md={
                        this.context.storeSettings.showEcommerceModule ===
                          true ||
                        this.context.storeSettings.showEcommerceModule ===
                          undefined
                          ? 5
                          : 8
                      }
                      className="m-0 p-0"
                    >
                      <div className="mx-2 p-3 bg-light border CornersRoundedSmall">
                        {/* Variant Type (desktop only) */}
                        {window.innerWidth > 900 && (
                          <FloatingLabel
                            label="Product Variant Type *"
                            className="mb-3"
                          >
                            <Form.Select
                              name="productVariantType"
                              value={
                                prod.productVariantType == null
                                  ? ""
                                  : Number(prod.productVariantType)
                              }
                              autoComplete="off"
                              required
                              onChange={this.handleInputChange}
                            >
                              <option value=""></option>
                              <option value={1}>Single</option>
                              <option value={2}>Multiple</option>
                              <option value={3}>SteelType</option>
                            </Form.Select>
                          </FloatingLabel>
                        )}

                        {/* Single or SteelType */}
                        {Number(prod.productVariantType) === 1 ||
                        Number(prod.productVariantType) === 3 ? (
                          <>
                            {/* SKU / HSN / Batch / Quality */}
                            <Row>
                              <Col>
                                <Form.Group className="mb-1">
                                  <small>SKU</small>

                                  <InputGroup size="sm">
                                    <Form.Control
                                      type="text"
                                      name="sku"
                                      className="text-center"
                                      maxLength={20}
                                      value={prod.sku || ""}
                                      autoComplete="off"
                                      onChange={this.handleInputChange}
                                    />

                                    <Button
                                      variant="outline-secondary"
                                      title="Auto-generate SKU"
                                      onClick={this.generateUniqueSKU}
                                      style={{ minWidth: "36px" }}
                                    >
                                      ⚡
                                    </Button>
                                  </InputGroup>
                                </Form.Group>
                              </Col>
                              <Col>
                                <FloatingLabel label="HSNCode" className="mb-1">
                                  <Form.Control
                                    type="text"
                                    name="hsncode"
                                    className="text-center"
                                    maxLength={40}
                                    value={prod.hsncode || ""}
                                    autoComplete="off"
                                    onChange={this.handleInputChange}
                                  />
                                </FloatingLabel>
                              </Col>
                              <Col>
                                <FloatingLabel label="BatchID" className="mb-1">
                                  <Form.Control
                                    type="text"
                                    name="batchId"
                                    className="text-center"
                                    maxLength={40}
                                    value={prod.batchId || ""}
                                    autoComplete="off"
                                    onChange={this.handleInputChange}
                                  />
                                </FloatingLabel>
                              </Col>
                              <Col>
                                <FloatingLabel
                                  label="QualityNo"
                                  className="mb-1"
                                >
                                  <Form.Control
                                    type="text"
                                    name="qualityId"
                                    className="text-center"
                                    maxLength={40}
                                    value={prod.qualityId || ""}
                                    autoComplete="off"
                                    onChange={this.handleInputChange}
                                  />
                                </FloatingLabel>
                              </Col>
                            </Row>
                            {/* SINGLE Variant */}
                            {Number(prod.productVariantType) === 1 && (
                              <>
                                {/* Price / MRP / Unit block */}
                                <div className="p-2 rounded bg-secondary text-white mb-2">
                                  <Row className="g-2 align-items-center text-center">
                                    <Col xs={12} md={3}>
                                      <div className="d-flex flex-column">
                                        <small className="d-md-block mb-1 fw-bold">
                                          P.Price / Unit*
                                        </small>
                                        <Form.Control
                                          type="number"
                                          name="purchasePrice"
                                          className="text-center"
                                          required
                                          style={{ fontSize: "16px" }}
                                          value={prod.purchasePrice ?? 0}
                                          autoComplete="off"
                                          onChange={this.handleInputChange}
                                        />
                                      </div>
                                    </Col>

                                    <Col xs={12} md={3}>
                                      <div className="d-flex flex-column">
                                        <small className="d-md-block mb-1 fw-bold">
                                          Retail MRP / Unit*
                                        </small>
                                        <Form.Control
                                          type="number"
                                          step="0.01"
                                          name="mrp"
                                          className="text-center"
                                          min={0}
                                          value={prod.mrp ?? 0}
                                          required
                                          style={{ fontSize: "16px" }}
                                          autoComplete="off"
                                          onChange={this.handleInputChange}
                                        />
                                      </div>
                                    </Col>
                                    <Col xs={12} md={3}>
                                      <div className="d-flex flex-column">
                                        <small className="d-md-block mb-1 fw-bold">
                                          WholeSale MRP
                                        </small>
                                        <Form.Control
                                          type="number"
                                          step="0.01"
                                          name="mrpWholeSale"
                                          className="text-center"
                                          min={0}
                                          value={prod.mrpWholeSale ?? 0}
                                          style={{ fontSize: "16px" }}
                                          autoComplete="off"
                                          onChange={this.handleInputChange}
                                        />
                                      </div>
                                    </Col>
                                    <Col xs={12} md={3}>
                                      <div className="d-flex flex-column">
                                        <small className="d-md-block mb-1 fw-bold">
                                          Super WholeSale MRP
                                        </small>
                                        <Form.Control
                                          type="number"
                                          step="0.01"
                                          name="mrpSuperWholeSale"
                                          className="text-center"
                                          min={0}
                                          value={prod.mrpSuperWholeSale ?? 0}
                                          style={{ fontSize: "16px" }}
                                          autoComplete="off"
                                          onChange={this.handleInputChange}
                                        />
                                      </div>
                                    </Col>
                                    <Col xs={12} md={3}>
                                      <div className="d-flex flex-column">
                                        <small className="d-md-block mb-1 fw-bold">
                                          GST
                                        </small>
                                        <Form.Control
                                          type="text"
                                          name="gst"
                                          className="text-center"
                                          value={prod.gst ?? ""}
                                          required
                                          style={{ fontSize: "16px" }}
                                          autoComplete="off"
                                          onChange={this.handleInputChange}
                                        />
                                      </div>
                                    </Col>

                                    <Col xs={12} md={3}>
                                      <div className="d-flex flex-column">
                                        <small className="d-md-block mb-1 fw-bold">
                                          UNIT*
                                        </small>
                                        <Form.Select
                                          name="unit"
                                          size="lg"
                                          className="text-center"
                                          value={prod.unit || "piece"}
                                          required
                                          autoComplete="off"
                                          onChange={this.handleInputChange}
                                        >
                                          <option value="piece">piece</option>
                                          <option value="gram">gram</option>
                                          <option value="kg">kg</option>
                                          <option value="ton">ton</option>
                                          <option value="ml">ml</option>
                                          <option value="liter">liter</option>
                                          <option value="meter">meter</option>
                                        </Form.Select>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>

                                {/* Selling Price Rule block */}
                                <div className="px-2 py-3 mb-3 rounded bg-info text-dark w-100">
                                  <Row className="g-2 align-items-center text-center">
                                    {/* On xs screens each column becomes full width and will stack */}
                                    <Col xs={12} md={4} className="text-start">
                                      <h6 className="mb-2 mb-md-0">
                                        Selling Price Rule
                                      </h6>
                                      <Form.Select
                                        name="sellingPriceBusinessRuleId"
                                        value={
                                          prod.sellingPriceBusinessRuleId ?? ""
                                        }
                                        autoComplete="off"
                                        onChange={this.handleInputChange}
                                        aria-label="Selling price rule"
                                      >
                                        <option value={""}>-- None --</option>
                                        {this.props.sellingPriceRules.map(
                                          (r) => (
                                            <option
                                              key={r.sellingPriceBusinessRuleId}
                                              value={
                                                r.sellingPriceBusinessRuleId
                                              }
                                            >
                                              {r.name}{" "}
                                              {r.isActive ? "" : " (inactive)"}
                                            </option>
                                          ),
                                        )}
                                      </Form.Select>
                                    </Col>

                                    <Col
                                      xs={6}
                                      md={2}
                                      className="d-flex flex-column align-items-center"
                                    >
                                      <small className="d-md-block mb-1">
                                        Disc %
                                      </small>
                                      <Form.Control
                                        type="number"
                                        name="discount"
                                        className="text-center"
                                        style={{
                                          fontSize: "16px",
                                          width: "100%",
                                        }}
                                        min={0}
                                        value={prod.discount ?? 0}
                                        required
                                        hidden={
                                          !!prod.sellingPriceBusinessRuleId
                                        }
                                        autoComplete="off"
                                        onChange={this.handleInputChange}
                                      />
                                    </Col>

                                    <Col
                                      xs={6}
                                      md={3}
                                      className="d-flex flex-column align-items-center"
                                    >
                                      <small className="d-md-block mb-1">
                                        Sell Price
                                      </small>

                                      {/* Show computed base price when no sellingPriceBusinessRuleId (keeps your logic) */}
                                      <span
                                        className="text-primary bg-white fw-bold p-1 border rounded-3 w-100 text-center"
                                        hidden={
                                          !!prod.sellingPriceBusinessRuleId
                                        }
                                        style={{ fontSize: "18px" }}
                                      >
                                        {Number(
                                          this.context.GetBasePrice?.(prod) ??
                                            0,
                                        ).toLocaleString(
                                          this.context.storeSettings
                                            ?.defaultLocale || "en-IN",
                                          {
                                            style: "currency",
                                            currency:
                                              this.context.storeSettings
                                                ?.defaultCurrency || "INR",
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 1,
                                          },
                                        )}
                                      </span>
                                    </Col>

                                    <Col
                                      xs={12}
                                      md={3}
                                      className="d-flex flex-column align-items-center"
                                    >
                                      <small className="d-md-block mb-1">
                                        InStock*
                                      </small>
                                      <Form.Control
                                        type="text"
                                        name="inStockQty"
                                        className="text-center fw-bold fs-5"
                                        value={prod.inStockQty ?? 0}
                                        required
                                        autoComplete="off"
                                        onChange={this.handleInputChange}
                                        style={{
                                          maxWidth: "220px",
                                          width: "100%",
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                </div>

                                {/* Storage Location Block */}
                                <div className="px-2 py-2 rounded bg-light text-dark border w-100">
                                  Storage Location
                                  <Row className="g-2 align-items-center text-center">
                                    <Col xs={12} md={3}>
                                      <Form.Select
                                        name="storeUnitId"
                                        value={
                                          this.state.prod.storeUnitId || ""
                                        }
                                        className="text-start"
                                        onChange={this.handleInputChange}
                                      >
                                        <option value="">Section</option>
                                        {this.state.storageUnits.map((u) => (
                                          <option key={u.id} value={u.id}>
                                            {u.unitName}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </Col>
                                    <Col xs={12} md={3}>
                                      <Form.Select
                                        name="tankId"
                                        value={this.state.prod.tankId || ""}
                                        className="text-start"
                                        disabled={!this.state.prod.storeUnitId}
                                        onChange={this.handleInputChange}
                                      >
                                        <option value="">
                                          {this.context.store.businessTypeId ===
                                          18
                                            ? "Tank"
                                            : "Aisle"}
                                        </option>
                                        {this.state.tanks.map((t) => (
                                          <option key={t.id} value={t.id}>
                                            {t.tankCode}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </Col>
                                    <Col xs={12} md={3}>
                                      <Form.Select
                                        name="partitionId"
                                        value={
                                          this.state.prod.partitionId || ""
                                        }
                                        className="text-start"
                                        disabled={!this.state.prod.tankId}
                                        onChange={this.handleInputChange}
                                      >
                                        <option value="">
                                          {this.context.store.businessTypeId ===
                                          18
                                            ? "Tank Partition"
                                            : "Bin"}
                                        </option>
                                        {this.state.partitions.map((p) => (
                                          <option key={p.id} value={p.id}>
                                            {p.partitionCode}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                </div>
                              </>
                            )}
                            {/* STEEL TYPE */}
                            {Number(prod.productVariantType) === 3 && (
                              <>
                                <div className="p-1 rounded bg-secondary text-white">
                                  <Row className="text-center">
                                    <Col>Thickness</Col>
                                    <Col>Width</Col>
                                    <Col>Length</Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Form.Control
                                        type="number"
                                        name="thickness"
                                        className="text-center"
                                        required
                                        style={{ fontSize: "16px" }}
                                        value={prod.thickness ?? 0}
                                        autoComplete="off"
                                        onChange={this.handleInputChange}
                                      />
                                    </Col>
                                    <Col>
                                      <Form.Control
                                        type="number"
                                        name="width"
                                        className="text-center"
                                        required
                                        style={{ fontSize: "16px" }}
                                        value={prod.width ?? 0}
                                        autoComplete="off"
                                        onChange={this.handleInputChange}
                                      />
                                    </Col>
                                    <Col>
                                      <Form.Control
                                        type="number"
                                        name="length"
                                        className="text-center"
                                        required
                                        style={{ fontSize: "16px" }}
                                        value={prod.length ?? 0}
                                        autoComplete="off"
                                        onChange={this.handleInputChange}
                                      />
                                    </Col>
                                  </Row>

                                  <Row className="text-center">
                                    <Col>UNIT*</Col>
                                    <Col>Purchased Price / {prod.unit}*</Col>
                                    <Col>
                                      Selling(MRP) Price / {prod.unit} *
                                    </Col>
                                    <Col>Disc %</Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Form.Select
                                        name="unit"
                                        size="lg"
                                        value={prod.unit || "piece"}
                                        required
                                        align="center"
                                        className="text-center"
                                        autoComplete="off"
                                        onChange={this.handleInputChange}
                                      >
                                        <option value="piece">piece</option>
                                        <option value="gram">gram</option>
                                        <option value="kg">kg</option>
                                        <option value="ton">ton</option>
                                        <option value="ml">ml</option>
                                        <option value="liter">liter</option>
                                        <option value="meter">meter</option>
                                      </Form.Select>
                                    </Col>
                                    <Col>
                                      <Form.Control
                                        type="number"
                                        name="purchasePrice"
                                        required
                                        className="text-center"
                                        style={{ fontSize: "16px" }}
                                        value={prod.purchasePrice ?? 0}
                                        autoComplete="off"
                                        onChange={this.handleInputChange}
                                      />
                                    </Col>
                                    <Col>
                                      <Form.Control
                                        type="number"
                                        step="0.01"
                                        name="mrp"
                                        className="text-center"
                                        min={0}
                                        value={prod.mrp ?? 0}
                                        required
                                        style={{ fontSize: "16px" }}
                                        autoComplete="off"
                                        onChange={this.handleInputChange}
                                      />
                                    </Col>
                                    <Col>
                                      <Form.Control
                                        type="number"
                                        name="discount"
                                        className="text-center"
                                        style={{ fontSize: "16px" }}
                                        min={0}
                                        value={prod.discount ?? 0}
                                        required
                                        autoComplete="off"
                                        onChange={this.handleInputChange}
                                      />
                                    </Col>
                                  </Row>
                                </div>

                                <div className="px-2 py-3 rounded bg-info text-dark text-center w-100">
                                  <Row>
                                    <Col>
                                      <h4>Selling Price/{prod.unit}</h4>
                                    </Col>
                                    <Col>
                                      <h4>
                                        {Number(prod.productVariantType) === 3
                                          ? "InStock [Pieces] "
                                          : "InStock*"}
                                      </h4>
                                    </Col>
                                    {Number(prod.productVariantType) === 3 && (
                                      <Col>
                                        <h4>InStock [{prod.unit}]</h4>
                                      </Col>
                                    )}
                                  </Row>
                                  <Row>
                                    <Col className="verticalaligncentertd">
                                      <h1 className="fw-bold bg-white text-success text-center border rounded-3 w-100 mt-2 p-1">
                                        <span className="text-primary">
                                          {Number(
                                            this.context.GetBasePrice?.(prod) ??
                                              0,
                                          ).toLocaleString(
                                            this.context.storeSettings
                                              ?.defaultLocale || "en-IN",
                                            {
                                              style: "currency",
                                              currency:
                                                this.context.storeSettings
                                                  ?.defaultCurrency || "INR",
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 1,
                                            },
                                          )}
                                        </span>
                                      </h1>
                                    </Col>

                                    <Col className="verticalaligncentertd">
                                      <Form.Control
                                        type="number"
                                        min={0}
                                        name="pieceCount"
                                        className="text-center fw-bold"
                                        style={{ fontSize: "22px" }}
                                        value={prod.pieceCount ?? 0}
                                        required
                                        autoComplete="off"
                                        onChange={this.handleInputChange}
                                      />
                                    </Col>

                                    {Number(prod.productVariantType) === 3 && (
                                      <Col>
                                        <Form.Control
                                          type="number"
                                          className="text-center fw-bold"
                                          style={{ fontSize: "22px" }}
                                          value={(
                                            (Number(prod.thickness || 0) *
                                              Number(prod.width || 0) *
                                              Number(prod.length || 0) *
                                              Number(prod.pieceCount || 0) *
                                              7.85) /
                                            1000000000
                                          ).toFixed(5)}
                                          required
                                          disabled
                                          autoComplete="off"
                                        />
                                      </Col>
                                    )}
                                  </Row>
                                </div>
                              </>
                            )}
                          </>
                        ) : Number(prod.productVariantType) === 2 ? (
                          <></>
                        ) : (
                          <></>
                        )}
                      </div>
                    </Col>

                    {/* Right Column: E-commerce */}
                    {showEcom && (
                      <Col md={4} className="m-0 p-0">
                        <div className="mx-2 p-3 bg-light border CornersRoundedSmall">
                          {/* Related Products SKU List */}
                          <Form.Group
                            as={Row}
                            className="mb-2"
                            controlId="relatedSkuList"
                          >
                            <Col sm={12}>
                              <Form.Label>
                                Related Products – SKU List (CSV format, e.g.,
                                5002,3006,4545)
                              </Form.Label>
                              <Form.Control
                                as="textarea"
                                name="relatedProductsSkuListByCsv"
                                rows={2}
                                maxLength={254}
                                value={prod.relatedProductsSkuListByCsv || ""}
                                placeholder="Enter comma-separated SKUs"
                                autoComplete="off"
                                onChange={this.handleInputChange}
                              />
                            </Col>
                          </Form.Group>

                          {/* Main Description */}
                          <Form.Group
                            as={Row}
                            className="mb-2"
                            controlId="mainDescription"
                          >
                            <Col sm={12}>
                              <Form.Label>
                                Main Description (up to 5000 characters, HTML
                                supported) &nbsp;&nbsp;
                                <a
                                  href="https://www.geeksforgeeks.org/most-commonly-used-tags-in-html"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i className="text-primary">
                                    HTML Tags Reference
                                  </i>
                                </a>
                              </Form.Label>
                              <Form.Control
                                as="textarea"
                                name="description"
                                rows={4}
                                maxLength={4999}
                                value={prod.description || ""}
                                placeholder="You can use basic HTML tags here"
                                autoComplete="off"
                                onChange={this.handleInputChange}
                              />
                            </Col>
                          </Form.Group>

                          {/* Detailed Description File */}
                          <Form.Group
                            as={Row}
                            className="mb-2"
                            controlId="descriptionFile"
                          >
                            <Col sm={12}>
                              <Form.Label>
                                Detailed Description (HTML File Upload, .html
                                only)
                              </Form.Label>
                              <Form.Select
                                name="description2FileName"
                                value={prod.description2FileName || ""}
                                autoComplete="off"
                                className="text-start"
                                onChange={this.handleInputChange}
                              >
                                <option value="">-- Select HTML File --</option>
                                {(this.context.images || [])
                                  .filter((file) =>
                                    (file?.name || "").includes(".html"),
                                  )
                                  .map((file) => (
                                    <option key={file.name} value={file.name}>
                                      {file.name}
                                    </option>
                                  ))}
                              </Form.Select>
                            </Col>
                          </Form.Group>

                          {/* Show On Portal */}
                          <Form.Group as={Row} className="mb-2">
                            <Form.Label column sm={8}>
                              Show on Portal?
                            </Form.Label>
                            <Col sm={4}>
                              <Switch
                                onChange={this.handleHidemeChange}
                                checked={!prod.hideMe}
                              />
                            </Col>
                          </Form.Group>

                          {/* Show When Out of Stock */}
                          <Form.Group as={Row} className="mb-2">
                            <Form.Label column sm={8}>
                              Show When Out-of-Stock?
                            </Form.Label>
                            <Col sm={4}>
                              <Switch
                                onChange={this.handleHidemeWhenOutOfStockChange}
                                checked={!prod.hideWhenOutOfStock}
                              />
                            </Col>
                          </Form.Group>
                        </div>
                      </Col>
                    )}
                  </Row>

                  {/* Multivariants */}
                  <br />
                  {Number(prod.productVariantType) === 2 && (
                    <div className="bg-light border p-2 m-2 CornersRoundedSmall">
                      <Row className="m-0">
                        <Col md={8} className="text-start text-dark my-3">
                          <h4 className="m-0">Product Variants</h4>
                        </Col>
                        <Col md={4} className="text-end align-bottom">
                          <Button
                            variant="primary"
                            onClick={this.handleAddProductMultiVariants}
                          >
                            + Add
                          </Button>
                        </Col>
                      </Row>

                      <Row className="m-0">
                        <Col md={12}>
                          <Table
                            bordered
                            size="sm"
                            className="text-start"
                            style={{ tableLayout: "fixed" }}
                          >
                            <thead className="bg-secondary text-white">
                              <tr className="text-center">
                                {prod.customField1 ? (
                                  <td>{prod.customField1}</td>
                                ) : null}
                                {prod.customField2 ? (
                                  <td>{prod.customField2}</td>
                                ) : null}
                                {prod.customField3 ? (
                                  <td>{prod.customField3}</td>
                                ) : null}
                                <td>SKU</td>
                                <td>Seq.No</td>
                                <td>MRP / Unit</td>
                                <td>Discount %</td>
                                <td>S.Price</td>
                                <td>InStock</td>
                                <td>Options</td>
                              </tr>
                            </thead>
                            <tbody>
                              {(productMultiVariants || []).map((row, i) => (
                                <tr
                                  key={`mv-${i}`}
                                  className="text-center align-middle"
                                >
                                  {prod.customField1 ? (
                                    <td>
                                      <Form.Select
                                        name="customValue1"
                                        value={row.customValue1 || ""}
                                        required
                                        autoComplete="off"
                                        onChange={(e) =>
                                          this.handleProductMultivariantChange(
                                            e,
                                            i,
                                          )
                                        }
                                      >
                                        <option value=""></option>
                                        {ProductDataTypeValues.filter(
                                          (f) =>
                                            f.dataTypeName ===
                                            prod.customField1,
                                        ).map((values) => (
                                          <option
                                            key={`${values.dataTypeName}-${values.value}`}
                                            value={values.value}
                                          >
                                            {values.value}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </td>
                                  ) : null}

                                  {prod.customField2 ? (
                                    <td>
                                      <Form.Select
                                        name="customValue2"
                                        value={row.customValue2 || ""}
                                        required
                                        autoComplete="off"
                                        onChange={(e) =>
                                          this.handleProductMultivariantChange(
                                            e,
                                            i,
                                          )
                                        }
                                      >
                                        <option value=""></option>
                                        {ProductDataTypeValues.filter(
                                          (f) =>
                                            f.dataTypeName ===
                                            prod.customField2,
                                        ).map((values) => (
                                          <option
                                            key={`${values.dataTypeName}-${values.value}`}
                                            value={values.value}
                                          >
                                            {values.value}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </td>
                                  ) : null}

                                  {prod.customField3 ? (
                                    <td>
                                      <Form.Select
                                        name="customValue3"
                                        value={row.customValue3 || ""}
                                        autoComplete="off"
                                        onChange={(e) =>
                                          this.handleProductMultivariantChange(
                                            e,
                                            i,
                                          )
                                        }
                                      >
                                        <option value=""></option>
                                        {ProductDataTypeValues.filter(
                                          (f) =>
                                            f.dataTypeName ===
                                            prod.customField3,
                                        ).map((values) => (
                                          <option
                                            key={`${values.dataTypeName}-${values.value}`}
                                            value={values.value}
                                          >
                                            {values.value}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </td>
                                  ) : null}

                                  <td>
                                    <Form.Control
                                      type="text"
                                      name="sku"
                                      value={row.sku || ""}
                                      className="text-center"
                                      autoComplete="off"
                                      onChange={(e) =>
                                        this.handleProductMultivariantChange(
                                          e,
                                          i,
                                        )
                                      }
                                    />
                                  </td>

                                  <td>
                                    <Form.Control
                                      type="number"
                                      min={1}
                                      name="seqNo"
                                      value={row.seqNo ?? 1}
                                      required
                                      className="text-center"
                                      autoComplete="off"
                                      onChange={(e) =>
                                        this.handleProductMultivariantChange(
                                          e,
                                          i,
                                        )
                                      }
                                    />
                                  </td>

                                  <td>
                                    <Form.Control
                                      type="number"
                                      name="mrp"
                                      value={row.mrp ?? 0}
                                      required
                                      className="text-center"
                                      autoComplete="off"
                                      onChange={(e) =>
                                        this.handleProductMultivariantChange(
                                          e,
                                          i,
                                        )
                                      }
                                    />
                                  </td>

                                  <td>
                                    <Form.Control
                                      type="number"
                                      name="discount"
                                      min={0}
                                      value={row.discount ?? 0}
                                      className="text-center"
                                      autoComplete="off"
                                      onChange={(e) =>
                                        this.handleProductMultivariantChange(
                                          e,
                                          i,
                                        )
                                      }
                                    />
                                  </td>

                                  <td className="text-center">
                                    <h3 className="m-0">
                                      {Number(
                                        (row.mrp || 0) -
                                          ((row.mrp || 0) *
                                            (row.discount || 0)) /
                                            100,
                                      ).toLocaleString(
                                        this.context.storeSettings
                                          ?.defaultLocale || "en-IN",
                                        {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 0,
                                          style: "currency",
                                          currency:
                                            this.context.storeSettings
                                              ?.defaultCurrency || "INR",
                                        },
                                      )}
                                    </h3>
                                  </td>

                                  <td>
                                    <Form.Control
                                      type="number"
                                      name="inStockQty"
                                      min={0}
                                      value={row.inStockQty ?? 0}
                                      className="text-center"
                                      autoComplete="off"
                                      onChange={(e) =>
                                        this.handleProductMultivariantChange(
                                          e,
                                          i,
                                        )
                                      }
                                    />
                                  </td>

                                  <td className="text-center">
                                    <OverlayTrigger
                                      overlay={<Tooltip>Delete!</Tooltip>}
                                    >
                                      <Button
                                        variant="outline-danger"
                                        onClick={() =>
                                          this.handleRemoveProductMultiVariantClick(
                                            i,
                                          )
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          className="bi bi-trash"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                          <path
                                            fillRule="evenodd"
                                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                                          />
                                        </svg>
                                      </Button>
                                    </OverlayTrigger>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </Col>
                      </Row>
                    </div>
                  )}

                  {/* Images (desktop only) */}
                  <br />
                  {window.innerWidth > 900 && showEcom && (
                    <div className="bg-light border p-2 m-2 CornersRoundedSmall">
                      <Row className="m-0">
                        <Col md={8} className="text-start text-dark my-3">
                          <h4 className="m-0">Product Images</h4>
                        </Col>
                        <Col md={4} className="text-end align-bottom">
                          <Button
                            variant="primary"
                            onClick={this.handleAddImages}
                          >
                            + Add
                          </Button>
                        </Col>
                      </Row>

                      <Row className="m-0 p-0 bg-light border">
                        <Col>
                          <Table bordered size="sm" className="text-start">
                            <thead className="bg-secondary text-white">
                              <tr>
                                <td width="40%">Image/Video FileName</td>
                                <td width="10%" className="text-center">
                                  Seq No
                                </td>
                                <td width="10%" className="text-center">
                                  Image
                                </td>
                                <td width="30%" className="text-center">
                                  Poster Image FileName (if Video)
                                </td>
                                <td width="10%" className="text-center">
                                  Options
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              {(productImages || []).map((row, i) => (
                                <tr
                                  key={`img-${i}`}
                                  className="align-middle"
                                  style={{ height: "30pt" }}
                                >
                                  <td>
                                    <Select
                                      value={{
                                        value: row.fileName || "",
                                        label: row.fileName || "",
                                      }}
                                      onChange={(e) =>
                                        this.handleImageSelectionChange(e, i)
                                      }
                                      options={images}
                                    />
                                  </td>
                                  <td>
                                    <Form.Control
                                      type="number"
                                      min={1}
                                      name="seqNo"
                                      value={row.seqNo ?? 1}
                                      required
                                      className="text-center"
                                      autoComplete="off"
                                      onChange={(e) =>
                                        this.handleImageseqNoChange(e, i)
                                      }
                                    />
                                  </td>
                                  <td className="text-center">
                                    {row.fileName ? (
                                      <img
                                        width="50"
                                        height="50"
                                        src={
                                          this.context.store.storageBlobUrl +
                                          this.context.store
                                            .storageBlobContainerName +
                                          "/images/" +
                                          row.fileName +
                                          this.context.store.storageSasToken
                                        }
                                        alt={row.fileName}
                                      />
                                    ) : null}
                                  </td>
                                  <td>
                                    <Select
                                      value={{
                                        value: row.posterName || "",
                                        label: row.posterName || "",
                                      }}
                                      onChange={(e) =>
                                        this.handlePosterSelectionChange(e, i)
                                      }
                                      options={images}
                                    />
                                  </td>
                                  <td className="text-center">
                                    <OverlayTrigger
                                      overlay={<Tooltip>Delete!</Tooltip>}
                                    >
                                      <Button
                                        variant="outline-danger"
                                        onClick={() =>
                                          this.handleRemoveClick(i)
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          className="bi bi-trash"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                          <path
                                            fillRule="evenodd"
                                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                                          />
                                        </svg>
                                      </Button>
                                    </OverlayTrigger>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </Col>
                      </Row>

                      {window.location.hostname ===
                        "green-admin.elasticcart.com" && (
                        <Row className="m-0">
                          <Col md={4} className="text-start text-dark my-3">
                            <h4 className="m-0">Right Image</h4>
                          </Col>
                          <Col
                            md={8}
                            className="text-start text-black align-bottom"
                          >
                            <Select
                              value={{
                                value: prod.image2 || "",
                                label: prod.image2 || "",
                              }}
                              onChange={this.Image2Change}
                              options={images}
                            />
                          </Col>
                        </Row>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" size="lg" type="submit">
                  Save
                </Button>
              </Form.Group>
              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default ProductAddOrEditModal;
